import React, { useState } from 'react';
import FileUpload from "./FileUpload";

const MaintenanceModal = ({ onConfirm, onCancel }) => {
  const [category, setCategory] = useState('');
  const [name, setName] = useState('');
  const [files, setFiles] = useState([]);

  const handleConfirm = () => {
     onConfirm({ name, category, files });
  };

  const handleCancel = () => {
     setName("");
     setFiles(null);
     if(onCancel) onCancel();
  }


  const handleUpload = (file) => {
    console.log('Uploaded file:', file);
    var new_files = [...files];
    new_files.push(file);
    setFiles(new_files);
    // You can process or upload the file here
  };


  return (
    <div className="modal-overlay">
      <div className="modal-box big-modal-box">
        <h2 className="modal-title">Aggiungi Intervento  <span onClick={handleCancel} className="close-popup">&#x2715;</span></h2>

        <form className="modal-form" onSubmit={(e) => e.preventDefault()}>
          <h3>Che tipologia di intervento vuoi caricare?</h3>

          <div className="form-group">
            <input
              name="category"
              type="radio"
              value="ispezione"
              className="checkbox-maintenance-modal"
              onChange={()=>setCategory("inspection")}
            />
            <label className="checkbox-maintenance-label">Ispezione</label>
          </div>
          <div className="form-group">
            <input
              name="category"
              type="radio"
              value="manutenzione"
              className="checkbox-maintenance-modal"
              onChange={()=>setCategory("restoration")}

            />
            <label className="checkbox-maintenance-label">Manutenzione</label>
          </div>
          <div className="form-group">
            <input
              name="category"
              type="radio"
              value="ripristino"
              className="checkbox-maintenance-modal"
              onChange={()=>setCategory("restoration")}

            />
            <label className="checkbox-maintenance-label">Ripristino</label>
          </div>


          {files.length > 0 && (
            <>
              <h3>Documenti caricati:</h3>
              {files.map((f, index) => (
                <div className="document-list-item" key={index}>{f.name}</div>
              ))}
            </>
          )}

          <h3>Carica nuovo documento</h3>

           <FileUpload onFileUpload={handleUpload} />

        </form>


        <div className="buttons">
          <button onClick={handleCancel} className="modal-button cancel-button">Indietro</button>
          <button onClick={handleConfirm} className="modal-button confirm-button">Salva</button>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceModal;
